import { FC, useState } from 'react';
import { BlockFormatType } from '../../textEditor.type';
import style from './ToolbarButton.module.scss';
import classnames from 'classnames/bind';
import Icon from '../../../icon/Icon';
import { COLORS } from '../../../../constants/colors';
import Popover from '../../../popover/Popover';
import VideoUploadInputPopover from './VideoUploadInputPopover';
const cx = classnames.bind(style);

const VideoUploadButton: FC<{ format: BlockFormatType }> = ({ format }) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const openPopover = () => setIsPopoverOpen(true);
  const closePopover = () => setIsPopoverOpen(false);
  return (
    <Popover
      isOpen={isPopoverOpen}
      content={<VideoUploadInputPopover format={format} close={closePopover} />}
      close={closePopover}
    >
      <button className={cx('container')} type={'button'} onClick={openPopover}>
        <Icon name={'youtube_filled'} color={COLORS.gray800} size={24} />
      </button>
    </Popover>
  );
};

export default VideoUploadButton;
